import React, {Component} from 'react'
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import FormInput from '../forms/FormInput';
import PrevNext from '../PrevNext';
import PropTypes from 'prop-types';

import ImageContainer from '../image-handler/ImageContainer';

import * as actions from '../../actions';

class Step3 extends Component {

    render() {
        return (
            <div className='row step-content'>
                <div className='row'>
                    <h5 className='col s6' >
                        {this.props.translate('BATHTUB.stepThree.menu.title')}
                    </h5>
                </div>
                <div className='col s12'>
                    <div className='row'>
                        <div className='col l4 s12'>
                            <FormInput
                                type='select'
                                options={this.props.bathtub.EA12.Values.Value}
                                label={this.props.translate('BATHTUB.stepThree.form.back_left')}
                                divClass='input-field col s12'
                                name='BATHTUB.EA12'
                                value={this.props.bathtub.EA12.CurrentValue}
                            />
                        </div>
                        <div className='col s12 l4 offset-l4'>
                            <FormInput
                                type='select'
                                options={this.props.bathtub.EA34.Values.Value}
                                label={this.props.translate('BATHTUB.stepThree.form.back_right')}
                                divClass='input-field col s12'
                                name='BATHTUB.EA34'
                                value={this.props.bathtub.EA34.CurrentValue}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <ImageContainer
                            image={this.props.image.Image}
                            name='bathtub'
                            divClass='col s12 m6 offset-m3'
                            height='100%' />
                    </div>
                    <div className='row'>
                        <div className='col col s12 l4'>
                            <FormInput
                                type='select'
                                options={this.props.bathtub.EA78.Values.Value}
                                label={this.props.translate('BATHTUB.stepThree.form.front_left')}
                                divClass='input-field col s12'
                                name='BATHTUB.EA78'
                                value={this.props.bathtub.EA78.CurrentValue}
                            />
                        </div>
                        <div className='col col s12 l4 offset-l4'>
                            <FormInput
                                type='select'
                                options={this.props.bathtub.EA56.Values.Value}
                                label={this.props.translate('BATHTUB.stepThree.form.front_right')}
                                divClass='input-field col s12'
                                name='BATHTUB.EA56'
                                value={this.props.bathtub.EA56.CurrentValue}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

Step3.propTypes = {
    lastStep:      PropTypes.number,
    bathtub:       PropTypes.object.isRequired,
    translate:     PropTypes.func.isRequired,
}

function mapStateToProps({bathtub, locale, image}) {
    return {
        translate: getTranslate(locale),
        bathtub,
        image,
    }
}

export default connect(mapStateToProps, actions)(Step3);



// WEBPACK FOOTER //
// ./src/components/bathtub-steps/Step3.js